//roi
import request from '@/utils/request';
export function rechargeLevelFightingDetail(data) {
  return request({
    url: '/data/recharge_level_fighting_detail',
    method: 'get',
    params: data
  });
}
export function rechargeLevelFightingDetailCurrency(data) {
  return request({
    url: '/data/recharge_level_fighting_detail_currency',
    method: 'get',
    params: data
  });
}
export function rechargeLevelDailyTaskDetail(data) {
  return request({
    url: '/data/recharge_level_daily_task_detail',
    method: 'get',
    params: data
  });
}
export function rechargeLevelDailyTaskDetailCurrency(data) {
  return request({
    url: '/data/recharge_level_daily_task_detail_currency',
    method: 'get',
    params: data
  });
}
export function analyzeLevelDuration(data) {
  return request({
    url: '/data/analyze_level_duration',
    method: 'get',
    params: data
  });
}
export function analyzeLevelDurationCurrency(data) {
  return request({
    url: '/data/analyze_level_duration_currency',
    method: 'get',
    params: data
  });
}
export function analyzeLevelRetentionByTier(data) {
  return request({
    url: '/data/analyze_level_Retention_by_tier',
    method: 'get',
    params: data
  });
}
export function analyzLevelRetentionByTierCurrency(data) {
  return request({
    url: '/data/analyze_level_Retention_by_tier_currency',
    method: 'get',
    params: data
  });
}
export function analyzeLevelDurationByAd(data) {
  return request({
    url: '/data/analyze_level_duration_by_ad',
    method: 'get',
    params: data
  });
}
export function analyzeLevelDurationByAdCurrency(data) {
  return request({
    url: '/data/analyze_level_duration_by_ad_currency',
    method: 'get',
    params: data
  });
}
export function rechargeTaskGressDetailCurrency(data) {
  return request({
    url: '/data/recharge_task_gress_detail_currency',
    method: 'get',
    params: data
  });
}
export function rechargeTaskGressDetail(data) {
  return request({
    url: '/data/recharge_task_gress_detail',
    method: 'get',
    params: data
  });
}
export function analyzeByLTVcurrency(data) {
  return request({
    url: '/data/analyze_by_ltv_currency',
    method: 'get',
    params: data
  });
}
export function analyzeByLTV(data) {
  return request({
    url: '/data/analyze_by_ltv',
    method: 'get',
    params: data
  });
}
export function analyzeByDurationCurrency(data) {
  return request({
    url: '/data/analyze_by_duration_currency',
    method: 'get',
    params: data
  });
}
export function analyzeByDuration(data) {
  return request({
    url: '/data/analyze_by_duration',
    method: 'get',
    params: data
  });
}
export function rechargeDailyLoginTaskCurrency(data) {
  return request({
    url: '/data/recharge_daily_login_task_currency',
    method: 'get',
    params: data
  });
}
export function rechargeDailyLoginTask(data) {
  return request({
    url: '/data/recharge_daily_login_task',
    method: 'get',
    params: data
  });
}
export function rechargeProducPenetrationRateCurrency(data) {
  return request({
    url: '/data/recharge_product_penetration_rate_currency',
    method: 'get',
    params: data
  });
}
export function rechargeProducPenetrationRate(data) {
  return request({
    url: '/data/recharge_product_penetration_rate',
    method: 'get',
    params: data
  });
}
export function rechargeProductAmountDetailCurrency(data) {
  return request({
    url: '/data/recharge_product_amount_detail_currency',
    method: 'get',
    params: data
  });
}
export function rechargeProductAmountDetail(data) {
  return request({
    url: '/data/recharge_product_amount_detail',
    method: 'get',
    params: data
  });
}
export function rechargeProductPenetCountCurrency(data) {
  return request({
    url: '/data/recharge_product_penet_count_currency',
    method: 'get',
    params: data
  });
}
export function rechargeProductPenetCount(data) {
  return request({
    url: '/data/recharge_product_penet_count',
    method: 'get',
    params: data
  });
}
export function rechargeSourceDetailCurrency(data) {
  return request({
    url: '/data/recharge_source_detail_currency',
    method: 'get',
    params: data
  });
}
export function rechargeSourceDetail(data) {
  return request({
    url: '/data/recharge_source_detail',
    method: 'get',
    params: data
  });
}
export function serverRoleByDurationCurrency(data) {
  return request({
    url: '/data/serverRoleByDurationCurrency',
    method: 'get',
    params: data
  });
}
export function serverRoleByDuration(data) {
  return request({
    url: '/data/serverRoleByDuration',
    method: 'get',
    params: data
  });
}
export function serverRoleRechargeDailyTaskDetailCurrency(data) {
  return request({
    url: '/data/serverRoleRechargeDailyTaskDetailCurrency',
    method: 'get',
    params: data
  });
}
export function serverRoleRechargeDailyTaskDetail(data) {
  return request({
    url: '/data/serverRoleRechargeDailyTaskDetail',
    method: 'get',
    params: data
  });
}
export function serverRoleRechargeLevelDetailCurrency(data) {
  return request({
    url: '/data/serverRoleRechargeLevelDetailCurrency',
    method: 'get',
    params: data
  });
}
export function serverRoleRechargeLevelDetail(data) {
  return request({
    url: '/data/serverRoleRechargeLevelDetail',
    method: 'get',
    params: data
  });
}
export function serverRoleProductPenetrationRateCurrency(data) {
  return request({
    url: '/data/serverRoleProductPenetrationRateCurrency',
    method: 'get',
    params: data
  });
}
export function serverRoleProductPenetrationRate(data) {
  return request({
    url: '/data/serverRoleProductPenetrationRate',
    method: 'get',
    params: data
  });
}
export function serverRoleProductAmountDetailCurrency(data) {
  return request({
    url: '/data/serverRoleProductAmountDetailCurrency',
    method: 'get',
    params: data
  });
}
export function serverRoleProductAmountDetail(data) {
  return request({
    url: '/data/serverRoleProductAmountDetail',
    method: 'get',
    params: data
  });
}
export function serverRoleProductPenetCountCurrency(data) {
  return request({
    url: '/data/serverRoleProductPenetCountCurrency',
    method: 'get',
    params: data
  });
}
export function serverRoleProductPenetCount(data) {
  return request({
    url: '/data/serverRoleProductPenetCount',
    method: 'get',
    params: data
  });
}
export function analyzeResourceInventoryCurrency(data) {
  return request({
    url: '/data/analyzeResourceInventoryCurrency',
    method: 'get',
    params: data
  });
}
export function analyzeResourceInventory(data) {
  return request({
    url: '/data/analyzeResourceInventory',
    method: 'get',
    params: data
  });
}
export function rechargeDailyPata(data) {
  return request({
    url: '/data/rechargeDailyPata',
    method: 'get',
    params: data
  });
}
export function oneAnalyzeByLtvCurrency(data) {
  return request({
    url: '/data/one_analyze_by_ltv_currency',
    method: 'get',
    params: data
  });
}
export function oneAnalyzeByLtv(data) {
  return request({
    url: '/data/one_analyze_by_ltv',
    method: 'get',
    params: data
  });
} //用户付费渗透率

export function newRechargeProductPenetrationRateCurrency(data) {
  return request({
    url: '/data/new_recharge_product_penetration_rate_currency',
    method: 'get',
    params: data
  });
}
export function newRechargeProductPenetrationRate(data) {
  return request({
    url: '/data/new_recharge_product_penetration_rate',
    method: 'get',
    params: data
  });
}
export function newRechargeProductAmountDetailCurrency(data) {
  return request({
    url: '/data/new_recharge_product_amount_detail_currency',
    method: 'get',
    params: data
  });
}
export function newRechargeProductAmountDetail(data) {
  return request({
    url: '/data/new_recharge_product_amount_detail',
    method: 'get',
    params: data
  });
}
export function newRechargeProductPenetCountCurrency(data) {
  return request({
    url: '/data/new_recharge_product_penet_count_currency',
    method: 'get',
    params: data
  });
}
export function newRechargeProductPenetCount(data) {
  return request({
    url: '/data/new_recharge_product_penet_count',
    method: 'get',
    params: data
  });
}
export function newServerRoleProductPenetrationRateCurrency(data) {
  return request({
    url: '/data/newServerRoleProductPenetrationRateCurrency',
    method: 'get',
    params: data
  });
}
export function newServerRoleProductPenetrationRate(data) {
  return request({
    url: '/data/newServerRoleProductPenetrationRate',
    method: 'get',
    params: data
  });
}
export function newServerRoleProductAmountDetailCurrency(data) {
  return request({
    url: '/data/newServerRoleProductAmountDetailCurrency',
    method: 'get',
    params: data
  });
}
export function newServerRoleProductAmountDetail(data) {
  return request({
    url: '/data/newServerRoleProductAmountDetail',
    method: 'get',
    params: data
  });
}
export function newServerRoleProductPenetCountCurrency(data) {
  return request({
    url: '/data/newServerRoleProductPenetCountCurrency',
    method: 'get',
    params: data
  });
}
export function newServerRoleProductPenetCount(data) {
  return request({
    url: '/data/newServerRoleProductPenetCount',
    method: 'get',
    params: data
  });
}
export function newRechargeProductDailySummary(data) {
  return request({
    url: '/data/new_recharge_product_daily_summary',
    method: 'get',
    params: data
  });
}
export function newRechargeProductDailySummaryCurrency(data) {
  return request({
    url: '/data/new_recharge_product_daily_summary_currency',
    method: 'get',
    params: data
  });
}
export function loginByDarpu(data) {
  return request({
    url: '/data/loginByDarpu',
    method: 'get',
    params: data
  });
}
export function loginByDarpuCurrency(data) {
  return request({
    url: '/data/loginByDarpuCurrency',
    method: 'get',
    params: data
  });
}
export function hdTaskFlowPercentByUser(data) {
  return request({
    url: '/data/hd-task-flow-percent-by-user',
    method: 'get',
    params: data
  });
}